import {
  createAll,
  Accordion,
  Button,
  CharacterCount,
  Checkboxes,
  ErrorSummary,
  Radios,
  SkipLink
} from 'govuk-frontend'

import { initCookieBanner, initCookiesPage } from './cookie-consent.js'
import { initSearch } from './search.js'
import { initRadar } from './radar.js'
import { initPatternFinder } from './pattern-finder.js'
import { initAsk } from './ask.js'
import { initTableScroll } from './table-scroll.js'

createAll(Accordion)
createAll(Button)
createAll(CharacterCount)
createAll(Checkboxes)
createAll(ErrorSummary)
createAll(Radios)
createAll(SkipLink)

/**
 * Service navigation mobile toggle
 * Shows/hides the navigation menu on mobile devices
 */
export function initServiceNavigation () {
  const toggleButton = document.querySelector('.js-service-navigation-toggle')
  const navList = document.getElementById('service-navigation-list')

  if (!toggleButton || !navList) {
    return
  }

  toggleButton.hidden = false

  toggleButton.addEventListener('click', function () {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true'
    toggleButton.setAttribute('aria-expanded', String(!isExpanded))
    navList.classList.toggle('defra-service-navigation__list--open')
  })
}

initCookieBanner()
initCookiesPage()
initServiceNavigation()
initSearch()
initRadar()
initPatternFinder()
initAsk()
initTableScroll()
